import { build } from './global'

build().mount('#app')
